//ADMIN
//ADD CATEGORIES
export const ADMIN_ADD_CATEGORIES_REQUEST = "ADMIN_ADD_CATEGORIES_REQUEST";
export const ADMIN_ADD_CATEGORIES_SUCCESS = "ADMIN_ADD_CATEGORIES_SUCCESS";
export const ADMIN_ADD_CATEGORIES_FAILURE = "ADMIN_ADD_CATEGORIES_FAILURE";
export const ADMIN_ADD_CATEGORIES_RESET = "ADMIN_ADD_CATEGORIES_RESET";

//ADMIN GET ALL CATEGORIES
export const ADMIN_CATEGORIES_LIST_REQUEST = "ADMIN_CATEGORIES_LIST_REQUEST";
export const ADMIN_CATEGORIES_LIST_SUCCESS = "ADMIN_CATEGORIES_LIST_SUCCESS";
export const ADMIN_CATEGORIES_LIST_FAILURE = "ADMIN_CATEGORIES_LIST_FAILURE";

//GET CATEGORIES BY ID
export const ADMIN_GET_CATEGORY_REQUEST = "ADMIN_GET_CATEGORY_REQUEST";
export const ADMIN_GET_CATEGORY_SUCCESS = "ADMIN_GET_CATEGORY_SUCCESS";
export const ADMIN_GET_CATEGORY_FAILURE = "ADMIN_GET_CATEGORY_FAILURE";

//UPDATE CATEGORIES
export const ADMIN_UPDATE_CATEGORY_STATUS_REQUEST =
  "ADMIN_UPDATE_CATEGORY_STATUS_REQUEST";
export const ADMIN_UPDATE_CATEGORY_STATUS_SUCCESS =
  "ADMIN_UPDATE_CATEGORY_STATUS_SUCCESS";
export const ADMIN_UPDATE_CATEGORY_STATUS_FAILURE =
  "ADMIN_UPDATE_CATEGORY_STATUS_FAILURE";
export const ADMIN_UPDATE_CATEGORY_STATUS_RESET =
  "ADMIN_UPDATE_CATEGORY_STATUS_RESET";

//DELETE CATEGORIES
export const ADMIN_DELETE_CATEGORY_REQUEST = "ADMIN_DELETE_CATEGORY_REQUEST";
export const ADMIN_DELETE_CATEGORY_SUCCESS = "ADMIN_DELETE_CATEGORY_SUCCESS";
export const ADMIN_DELETE_CATEGORY_FAILURE = "ADMIN_DELETE_CATEGORY_FAILURE";
